export default "__VITE_ASSET__BQzF$6Bt__"